/**
 * Feature toggle to consolidate the Stores and Addresses page into a single revamped page
 */
export const STORES_AND_ADDRESSES_PAGE_CONSOLIDATION_240703 = 'STORES_AND_ADDRESSES_PAGE_CONSOLIDATION_240703';
